import React from 'react';
import PropTypes from 'prop-types';
import ContributionMargin from './components/ContributionMargin';

const PropertyCostAnalysis = ({ selectedCrop = null }) => {
  return <ContributionMargin selectedCrop={selectedCrop} />;
};

PropertyCostAnalysis.propTypes = {
  selectedCrop: PropTypes.string
};

export default PropertyCostAnalysis;
